<template>
  <div>    
    <ProductsGrid :Category="Category"></ProductsGrid>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ProductsGrid from "@/view/shop/products/Products-grid";

export default {
  name: "line-base",
  components: {
    ProductsGrid,
  },  
  data() {
    return {
      Category: this.$route.params.category,
    }
  },
  mounted() {
    // console.log(this.$route.params);
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Shop > " + this.Category, route: `/shop/`}]);
    // console.log(this.lineId);
  },
  methods: {
  }
};
</script>
